import { Box, Text } from '@user-portal/wikr-components';
import styled from 'styled-components';

export const Container = styled(Box)`
    width: 100%;
    border-radius: 20px;
    ${({ $mb }) => Boolean($mb) && `margin-bottom: ${$mb}px;`};
`;

export const Badge = styled(Box)`
    width: 100%;
    border-radius: 20px 20px 0 0;
    ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]};`};
    ${({ $mb }) => Boolean($mb) && `margin-bottom: ${$mb}px;`};
`;

export const Details = styled(Box)`
    width: 100%;
    border-radius: 0 0 20px 20px;
    ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]};`};
    ${({ $paddingTop }) => Boolean($paddingTop) && `padding-top: ${$paddingTop}px;`};
    ${({ $paddingX }) => Boolean($paddingX) && `padding-left: ${$paddingX}px; padding-right: ${$paddingX}px;`};

    ${({ $paddingBottom }) => Boolean($paddingBottom) && `padding-bottom: ${$paddingBottom}px;`};
`;

export const CrossedText = styled(Text)`
    text-decoration: line-through;
    text-decoration-color: #482525;
`;

export const Period = styled.span`
    font-size: 18px;
    font-weight: 500;
    line-height: 28px;
`;
